









import { defineComponent } from '@vue/composition-api';
import RestrictedBannerContent from './RestrictedBannerContent.vue';

export default defineComponent({
  components: {
    RestrictedBannerContent,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  emits: ['contact'],
});
